import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { makeStyles, Grid, Typography } from "@material-ui/core";

import { KPIS } from "../constants";
import { TwentyYear } from "../../../components/units";
import { Icon, LinearProgress } from "../../../components/base";
import { ShaDowBox, CardBox } from "../../../components/boxes";
import CoinsImg from "../../../assets/images/dashboard/coins.svg";
import { api, requestDateFormat, currencyFormatter, getPercent } from "../../../services";

const useStyles = makeStyles((theme) => ({
  container: {
    flexWrap: "noWrap",
  },
  icon: {
    marginRight: theme.spacing(1.5),
  },
}));

const initialData = {
  per_date: 0,
  per_20y: 0,
};

export const PowerRevenueKPI = ({ activeKpi, setActiveKpi, period, startDate, endDate }) => {
  const classes = useStyles();
  const [data, setData] = useState(initialData);
  const currencySymbol = useSelector((state) => state.auth.user.currency.symbol);

  useEffect(() => {
    const getData = (url) => {
      api.get(url).then((resp) => setData(resp.data));
    };

    const getUrl = (period) => {
      let url = "/praas/v1/dashboard/power-revenue/";
      if (period.name === "RANGE" && endDate) {
        url += `?from_date=${requestDateFormat(startDate)}&to_date=${requestDateFormat(endDate)}`;
        getData(url);
      } else if (["YTD", "Acc.", "20Y"].includes(period.name)) {
        url += `?date_filter=${period.filter}`;
        getData(url);
      }
    };

    getUrl(period);
  }, [period, startDate, endDate]);

  return (
    <Grid
      id="power-revenue-kpi"
      item
      style={{ flex: 1 }}
      onClick={() => setActiveKpi(KPIS.power_revenue)}
    >
      <ShaDowBox active={activeKpi === KPIS.power_revenue} hoverable>
        <CardBox>
          <Grid className={classes.container} container>
            <Icon root={classes.icon} src={CoinsImg} />
            <div>
              <Typography
                color={activeKpi === KPIS.power_revenue ? "primary" : "initial"}
                variant="h2"
                style={{ fontWeight: "bold" }}
              >
                {currencyFormatter(data.per_date, currencySymbol)}
              </Typography>
              <Typography>Power Revenue</Typography>
            </div>
          </Grid>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item xs={7}>
              <LinearProgress
                active={activeKpi === KPIS.power_revenue}
                variant="determinate"
                value={getPercent(data.per_date, data.per_20y)}
              />
            </Grid>
            <Typography align="right">{currencyFormatter(data.per_20y, currencySymbol)}</Typography>
            <TwentyYear />
          </Grid>
        </CardBox>
      </ShaDowBox>
    </Grid>
  );
};
